// extracted by mini-css-extract-plugin
module.exports = {"tagsWrapper":"member-tags_tagsWrapper__3HgJV","tagElement":"member-tags_tagElement__1TxG3","showMore":"member-tags_showMore__bqR4n"};